module.exports = __webpack_public_path__ + "img/hr-sand-rock-medium-09.9cafc4af.png";